import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const LeftAndRightContentPackageLoadable = loadable(
  () => import('./LeftAndRightContentPackage'),
  {
    resolveComponent: components => components.LeftAndRightContentPackage
  }
);

export const LeftAndRightContentPackage = WithLazyHydration(
  LeftAndRightContentPackageLoadable,
  {
    name: 'LeftAndRightContentPackage'
  }
);
